import Typography from "@mui/material/Typography";
import linkifyHtml from "linkify-html";

const LINK_COLOR = "#00A3FF";

const LINKIFY_OPTIONS = {
  attributes: {
    rel: "noopener noreferrer",
    target: "_blank",
  },
};

const COMMENT_BODY_SX = {
  whiteSpace: "pre-wrap",
  color: "text.primary",
  "& a": {
    color: LINK_COLOR,
    textDecoration: "underline",
    "&:hover": {
      color: LINK_COLOR,
    },
  },
};

const CampaignApprovalCommentBody = ({
  body = "",
  variant = "body2",
  sx = {},
}) => {
  const normalizedBody = String(body || "");

  return (
    <Typography
      variant={variant}
      sx={{ ...COMMENT_BODY_SX, ...sx }}
      dangerouslySetInnerHTML={{
        __html: linkifyHtml(normalizedBody, LINKIFY_OPTIONS),
      }}
    />
  );
};

export default CampaignApprovalCommentBody;
